module.exports = __webpack_public_path__ + "static/media/blog1_3.a5c78e82.png";